import {inject} from 'mobx-react';
import {IInjectedProps} from '../../interface/component/injected-props.interface';
import Helmet from 'react-helmet-async';
import * as React from 'react';

export const CookieInformationPolicy = inject('state')((props: IInjectedProps) => {
  if (!props.state.configuration.inAdmin && props.state.adminSettings.enableCookieInformationPolicy) {
    const script1 = <script
      id="CookieConsent"
      data-culture={props.state.adminSettings.cookieInformationLanguage || 'EN'}
      type="text/javascript"
      src="https://policy.app.cookieinformation.com/uc.js"
      data-gcm-version="2.0"
      nonce={(window as any).__nonce__}
    />;
    return <Helmet>
      {script1}
    </Helmet>;
  } else {
    return <></>;
  }
});